module.exports = __webpack_public_path__ + "img/tick-circle.b3517438.svg";